export default __webpack_public_path__ + "static/media/banner_left.7f5d03c3.svg";